import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: [],
};

export const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload.permissions || [];
    },
  },
});

export const { setPermissions } = userPermissionsSlice.actions;
export const selectUserPermissions = (state) =>
  state.userPermissions.permissions;

export const userPermissionsReducer = userPermissionsSlice.reducer;
